import styled from 'styled-components'
import TitleColumn from 'components/common/titleColumn'
import { sizeMobile, gutter, gridGap } from 'components/globalStyles'
import { GridMixin, FadeUpMixin } from 'components/common/common_styles'

export const TextColumn = styled(TitleColumn)`
  grid-area: text;
`

export const ImageContainer = styled.div`
  grid-area: image;
  ${FadeUpMixin};
`

export const GridContainer = styled.div`
  ${GridMixin};
  grid-template-columns: 1fr minmax(auto, 45%);
  grid-template-areas: 'image text';
  row-gap: 32px;

  &:nth-child(1) {
    & > ${TextColumn} {
      padding-top: calc(48px + ${gridGap});

      @media (max-width: ${sizeMobile}) {
        padding-top: 0;
        padding-left: ${gutter};
      }
    }
  }

  &:nth-child(2) {
    grid-template-columns: minmax(auto, 45%) 0.85fr;
    grid-template-areas: 'text image';
    padding-left: ${gutter};
    align-self: center;

    & > ${TextColumn} {
      align-self: center;
    }

    @media (max-width: ${sizeMobile}) {
      grid-template-columns: 1fr;
      grid-template-areas:
        'image'
        'text';

      & > ${ImageContainer} {
        justify-self: end;
        max-width: 75%;
      }
    }
  }

  &:nth-child(3) {
    padding-left: ${gutter};

    & > ${ImageContainer} {
      align-self: end;
    }

    & > ${TextColumn} {
      align-self: end;
      padding-bottom: calc(48px + ${gridGap});

      @media (max-width: ${sizeMobile}) {
        padding-bottom: 0;
      }
    }
  }

  @media (max-width: ${sizeMobile}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'image'
      'text';
  }
`
